import { css } from '@linaria/atomic'
import type { SplitSpecs } from '../utilities/splitView'
import { FloaterPageState, FloaterSize } from './enums'

export const QUICK_REPLY = 'QUICK_REPLY'
export const FLOATING_PREVIEW = 'FLOATING_PREVIEW'
export const FLOATING_ROOM = 'FLOATING_ROOM'
export const FLOATING_DEBUG = 'FLOATING_DEBUG'
export const MY_WEBCAM = 'MY_WEBCAM'
export const MINI_PLAYER = 'MINI_PLAYER'

const landscapeStyles = css`
    top: var(--header-height);
    left: var(--nav-width);
`
const landscapeExpandedNavStyles = css`
    top: var(--header-height);
    left: var(--nav-expanded-width);
`
const landscapeExpandedSidebarStyles = css`
    top: var(--header-height);
    left: var(--nav-width);
`
const landscapeExpandedAllStyles = css`
    top: var(--header-height);
    left: var(--nav-expanded-width);
`
const landscapeContentStyles = css`
    top: var(--header-height);
    left: var(--nav-width);
`
const landscapeExpandedNavContentStyles = css`
    top: var(--header-height);
    left: var(--nav-expanded-width);
`
const landscapeExpandedSidebarContentStyles = css`
    top: var(--header-height);
    left: var(--nav-width);
`
const landscapeExpandedAllContentStyles = css`
    top: var(--header-height);
    left: var(--nav-expanded-width);
`
const fullWindowStyles = css`
    top: 0;
    left: 0;
`
const portraitStyles = css`
    top: var(--header-height);
    left: 0;
`
const portraitExpandedSidebarStyles = css`
    top: var(--header-height);
    left: 0;
`
const portraitContentStyles = css`
    top: var(--header-height);
    left: 0;
`
const portraitExpandedSidebarContentStyles = css`
    top: var(--header-height);
    left: 0;
`
const landscapeSizeStyles = css`
    --room-width: calc(100% - var(--nav-width));
    --room-height: calc(100% - var(--header-height));
`
const landscapeExpandedNavSizeStyles = css`
    --room-width: calc(100% - var(--nav-expanded-width));
    --room-height: calc(100% - var(--header-height));
`
const landscapeExpandedSidebarSizeStyles = css`
    --room-width: calc(100% - var(--nav-sidebar-width));
    --room-height: calc(100% - var(--header-height));
`
const landscapeExpandedAllSizeStyles = css`
    --room-width: calc(100% - var(--nav-expanded-all-width));
    --room-height: calc(100% - var(--header-height));
`
const landscapeContentSizeStyles = css`
    --room-width: calc(100% - var(--nav-width));
    --room-height: calc(100% - var(--header-height));
`
const landscapeExpandedNavContentSizeStyles = css`
    --room-width: calc(100% - var(--nav-expanded-width));
    --room-height: calc(100% - var(--header-height));
`
const landscapeExpandedSidebarContentSizeStyles = css`
    --room-width: calc(100% - var(--nav-sidebar-width));
    --room-height: calc(100% - var(--header-height));
`
const landscapeExpandedAllContentSizeStyles = css`
    --room-width: calc(100% - var(--nav-expanded-all-width));
    --room-height: calc(100% - var(--header-height));
`
const fullWindowSizeStyles = css`
    --room-width: 100%;
    --room-height: 100%;
`
const portraitSizeStyles = css`
    --room-width: 100%;
    --room-height: calc(
        100% - var(--portrait-compact-header-nav) - var(--saib)
    );
`
const portraitExpandedSidebarSizeStyles = css`
    --room-width: calc(100% - var(--sidebar-width));
    --room-height: calc(
        100% - var(--portrait-compact-header-nav) - var(--saib)
    );
`
const portraitContentSizeStyles = css`
    --room-width: 100%;
    --room-height: calc(
        100% - var(--portrait-compact-header-nav) - var(--saib)
    );
`
const portraitLandscapeMedianSizeStyles = css`
    --room-width: 100%;
    --room-height: calc(100% - var(--portrait-header-nav) - var(--saib));
`
const portraitExpandedSidebarContentSizeStyles = css`
    --room-width: calc(100% - var(--sidebar-width));
    --room-height: calc(
        100% - var(--portrait-compact-header-nav) - var(--saib)
    );
`

const stylesButtonPosition = css`
    right: -28px;
    top: -28px;
`

const stylesButtonPositionMedium = css`
    right: -28px;
    top: -24px;
`
export const BUTTON_ROOT_LOCATION_MAP_CSS = {
    [FloaterSize.Fullscreen]: '',
    [FloaterSize.Small]: stylesButtonPosition,
    [FloaterSize.Medium]: stylesButtonPositionMedium,
    [FloaterSize.Large]: stylesButtonPosition,
}

const stylesSideButtonPosition = css`
    right: -28px;
    top: 10px;
`

const stylesSideButtonPositionMedium = css`
    right: -28px;
    top: 14px;
`

export const SIDE_BUTTON_ROOT_LOCATION_MAP_CSS = {
    [FloaterSize.Fullscreen]: '',
    [FloaterSize.Small]: stylesSideButtonPosition,
    [FloaterSize.Medium]: stylesSideButtonPositionMedium,
    [FloaterSize.Large]: stylesSideButtonPosition,
}

export const FULLPAGE_LOCATION_STYLE_MAP = {
    [FloaterPageState.FULL_WINDOW]: fullWindowStyles,

    [FloaterPageState.LANDSCAPE]: landscapeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_NAV]: landscapeExpandedNavStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_SIDEBAR]:
        landscapeExpandedSidebarStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_ALL]: landscapeExpandedAllStyles,
    [FloaterPageState.PORTRAIT]: portraitStyles,
    [FloaterPageState.PORTRAIT_EXPANDED_SIDEBAR]: portraitExpandedSidebarStyles,
    [FloaterPageState.PORTRAIT_LANDSCAPE_MEDIAN]: portraitStyles,

    [FloaterPageState.LANDSCAPE_CONTENT]: landscapeContentStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_NAV_CONTENT]:
        landscapeExpandedNavContentStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_SIDEBAR_CONTENT]:
        landscapeExpandedSidebarContentStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_ALL_CONTENT]:
        landscapeExpandedAllContentStyles,
    [FloaterPageState.PORTRAIT_CONTENT]: portraitContentStyles,
    [FloaterPageState.PORTRAIT_EXPANDED_SIDEBAR_CONTENT]:
        portraitExpandedSidebarContentStyles,
}
export const FULLPAGE_SIZE_STYLE_MAP = {
    [FloaterPageState.FULL_WINDOW]: fullWindowSizeStyles,

    [FloaterPageState.LANDSCAPE]: landscapeSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_NAV]: landscapeExpandedNavSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_SIDEBAR]:
        landscapeExpandedSidebarSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_ALL]: landscapeExpandedAllSizeStyles,
    [FloaterPageState.PORTRAIT]: portraitSizeStyles,
    [FloaterPageState.PORTRAIT_EXPANDED_SIDEBAR]:
        portraitExpandedSidebarSizeStyles,
    [FloaterPageState.PORTRAIT_LANDSCAPE_MEDIAN]:
        portraitLandscapeMedianSizeStyles,

    [FloaterPageState.LANDSCAPE_CONTENT]: landscapeContentSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_NAV_CONTENT]:
        landscapeExpandedNavContentSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_SIDEBAR_CONTENT]:
        landscapeExpandedSidebarContentSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_ALL_CONTENT]:
        landscapeExpandedAllContentSizeStyles,
    [FloaterPageState.PORTRAIT_CONTENT]: portraitContentSizeStyles,
    [FloaterPageState.PORTRAIT_EXPANDED_SIDEBAR_CONTENT]:
        portraitExpandedSidebarContentSizeStyles,
}

// the room's video keeps sizing from its uncapped share, so capping the
// list gives the recovered width to chat
export const PM_SPLIT_SPECS: SplitSpecs = {
    0: { aWidth: '40%', bWidth: '60%' },
    720: { aWidth: '35%', bWidth: '65%' },
    960: { aWidth: '28%', bWidth: '72%' },
    1280: { aWidth: '24%', bWidth: '76%' },
    1600: { aWidth: '20%', bWidth: '80%' },
}
export const PM_LIST_MAX_WIDTH = 280
